/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value) {
    var isInstance = true;
    return isInstance;
}
export function AddressFromJSON(json) {
    return AddressFromJSONTyped(json, false);
}
export function AddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'addressLine1': !exists(json, 'addressLine1') ? undefined : json['addressLine1'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'addressLine2': !exists(json, 'addressLine2') ? undefined : json['addressLine2']
    };
}
export function AddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'postalCode': value.postalCode,
        'country': value.country,
        'addressLine1': value.addressLine1,
        'city': value.city,
        'addressLine2': value.addressLine2
    };
}
